module.exports = __webpack_public_path__ + "img/bg-header@3x.f913949.jpg";